import { DropTarget } from 'react-dnd';
import { NativeTypes } from 'react-dnd-html5-backend';

const types = [NativeTypes.FILE];

const spec = {
  drop(props, monitor, component) {
    if (component && component.createLesson) {
      component.createLesson(null, monitor.getItem().files);
    }
  },
};

const collect = (connector, monitor) => ({
  connectDropTarget: connector.dropTarget(),
  isOver: monitor.isOver(),
});

export default DropTarget(types, spec, collect);
